import { useState, useEffect } from "react";
import { List, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { LOGO } from "@/data/content";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why-us" },
  { label: "Team", href: "#team" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = ({ onBook }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-slate-200 shadow-sm" : "bg-transparent"
      }`}
    >
      <nav className="w-full max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#home" data-testid="navbar-logo" className="flex items-center gap-3">
          <img src={LOGO} alt="JP Accounts & Tax Consultants" className="h-11 w-11 rounded-lg object-contain" />
          <span className="font-display text-base md:text-xl font-bold text-navy leading-tight hidden sm:block">
            JP Accounts <span className="text-gold">&</span> Tax Consultants
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className="link-underline text-sm font-medium text-navy/80 hover:text-gold transition-colors duration-200">
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Button onClick={onBook} data-testid="navbar-book-btn"
            className="btn-shine hidden sm:flex rounded-full bg-gold hover:bg-gold-hover text-white font-semibold px-6 transition-all duration-300 hover:shadow-lg hover:shadow-gold/30">
            Book Consultation
          </Button>
          <button className="lg:hidden text-navy" onClick={() => setOpen((o) => !o)} data-testid="navbar-menu-toggle" aria-label="Menu">
            {open ? <X size={26} /> : <List size={26} />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200 px-6 py-4" data-testid="mobile-menu">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(" ", "-")}`}
                className="py-3 text-navy font-medium border-b border-slate-100">
                {l.label}
              </a>
            ))}
            <Button onClick={() => { setOpen(false); onBook(); }} data-testid="mobile-book-btn"
              className="mt-4 rounded-full bg-gold hover:bg-gold-hover text-white font-semibold">
              Book Free Consultation
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};
